import { makeStyles } from "@material-ui/core/styles";
import { Checkbox } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";

export const useStyles = makeStyles((theme) => ({
  headerText: {
    fontSize: 16,
    width: "fit-content",
    margin: "0 20px 0 0",
  },
  paymentBody: {
    display: "grid",
    gridTemplateColumns: "minmax(300px, 360px) minmax(70%, 1fr)",
    height: "100%",
    width: "100%",
    minHeight: "calc(100vh - 5rem)",
  },
  asideHeader: {
    fontSize: 18,
    color: "#272D3B",
  },
  paymentOption: {
    display: "flex",
    width: "100%",
    padding: "19px 17px",
    borderRadius: 8,
    border: "0.4000000059604645px solid",
    marginBottom: 20,
    cursor: "pointer",
  },
  leftSection: {
    flexBasis: "auto",
    paddingRight: 10,
  },
  rightSection: {
    flexBasis: "100%",
  },
  paymentOptionTitle: {
    fontSize: 18,
    margin: "0 0 10px 0",
  },
  paymentTypesBox: {
    marginRight: 10,
    backgroundColor: "#ffffff",
    border: "0.4000000059604645px solid #E2E2E2",
    borderRadius: 5,
    position: "relative",
    display: "inline-block",
    overflow: "hidden",
    width: 54,
    height: 38,
    "& > img": {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    },
  },
  lazypayImage: {
    width: "95%",
    height: 40,
  },
  radioButton: {
    width: 22,
    height: 22,
    borderRadius: 50,
    border: "3px solid",
    position: "relative",
    backgroundColor: "transparent",
    marginTop: 2,
  },
  radioButtonInner: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 10,
    height: 10,
    borderRadius: 50,
  },
  paymentMain: {
    height: "100%",
  },
  paymentInner: {
    maxWidth: 500,
    width: "100%",
    borderRadius: 8,
  },
}));

export const CustomCheckbox = withStyles({
  root: {
    color: "rgba(0,0,0,0.21)",
    padding: 0,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  checked: {
    color: "rgb(58, 142, 13)!important",
  },
})(Checkbox);
